import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useAppSelector } from 'src/store';
import { TicketStatusSelect } from 'src/components/Integrations/IntegrationForms/IntegrationFormFields/TicketStatusSelect/TicketStatusSelect';
import { InputInfoToolTip } from 'src/components/Input/InputInfoToolTip';

export const EditZendeskEmailAutoSetupSettings = ({
  statusFields,
  isError,
}: {
  statusFields: { id: string | number | null; agent_label: string }[];
  isError: boolean;
}) => {
  const { selectedIntegration } = useAppSelector((s) => s.integrationSlices);

  const updateStatuses = () => {
    if (selectedIntegration.integration_data.ticket_status_after_ai_response) {
      const selectedField = statusFields.find(
        (field) =>
          field.agent_label ===
          selectedIntegration.integration_data.ticket_status_after_ai_response,
      );

      selectedField
        ? resetField('ticket_status_after_ai_response', { defaultValue: selectedField.agent_label })
        : resetField('ticket_status_after_ai_response', {
            defaultValue: statusFields[0]?.agent_label,
          });
    }

    if (selectedIntegration.integration_data.ticket_status_after_escalation) {
      const selectedField = statusFields.find(
        (field) =>
          field.agent_label === selectedIntegration.integration_data.ticket_status_after_escalation,
      );

      selectedField
        ? resetField('ticket_status_after_escalation', { defaultValue: selectedField.agent_label })
        : resetField('ticket_status_after_escalation', {
            defaultValue: statusFields[0]?.agent_label,
          });
    }
  };

  useEffect(() => {
    if (statusFields) {
      updateStatuses();
    }
  }, [statusFields]);

  const { control, resetField } = useFormContext();

  return (
    <div className={'w-full flex flex-col gap-2.5 p-2.5 bg-[#A498FF1A] rounded-sm-5'}>
      {!isError ? (
        statusFields.length > 1 && (
          <div className={'flex flex-col gap-2.5'}>
            <TicketStatusSelect
              label={
                <div className={'flex flex-row gap-2 items-center mb-1'}>
                  Ticket status after AI response{' '}
                  <InputInfoToolTip
                    infoToolTip={{
                      side: 'right',
                      description: <>Status assigned to a ticket after the AI sends a response.</>,
                    }}
                  />
                </div>
              }
              control={control}
              name={'ticket_status_after_ai_response'}
              options={statusFields}
            />
            <TicketStatusSelect
              label={
                <div className={'flex flex-row gap-2 items-center mb-1'}>
                  Ticket status after AI escalation{' '}
                  <InputInfoToolTip
                    infoToolTip={{
                      side: 'right',
                      description: (
                        <>Status assigned to a ticket after the AI escalates it to a human.</>
                      ),
                    }}
                  />
                </div>
              }
              control={control}
              name={'ticket_status_after_escalation'}
              options={statusFields}
            />
          </div>
        )
      ) : (
        <p>
          The Zendesk details you entered seem invalid. Please double-check your subdomain, email,
          and API token following{' '}
          <a href={selectedIntegration.setupGuideUrl} target="_blank" rel="noreferrer">
            this guide
          </a>
          {'.'}
        </p>
      )}
    </div>
  );
};
